export const SET_ID = 'SET_ID'
export const SET_ADDRESS = 'SET_ADDRESS'
export const SET_NAME = 'SET_NAME'
export const SET_ARRIVAL_INFO = 'SET_ARRIVAL_INFO'
export const SET_ROOM_INFO = 'SET_ROOM_INFO'
export const SET_RESERVE_REMARK = 'SET_RESERVE_REMARK'
export const SET_START_DAY = 'SET_START_DAY'
export const SET_END_DAY = 'SET_END_DAY'
export const SET_DAYS = 'SET_DAYS'
export const SET_TOTALPRICE = 'SET_TOTALPRICE'
